import React, { useState } from "react";
import { ShieldCheck } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { getJSON, setJSON, K } from "../lib/storage";

export default function ConsentModal() {
  const [accepted, setAccepted] = useState(() => getJSON(K.consent, false));

  if (accepted) return null;

  const accept = () => {
    setJSON(K.consent, { accepted: true, at: new Date().toISOString() });
    setAccepted(true);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-[#36302B]/45 p-4 sm:items-center">
      <div
        data-testid="consent-modal"
        className="w-full max-w-[440px] rounded-[28px] bg-[#FAF8F5] p-7 shadow-2xl fade-up"
      >
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#9CAEA9]/20">
          <ShieldCheck size={28} color="#88A096" weight="duotone" />
        </div>
        <h2 className="font-display text-2xl font-medium text-[#36302B]">Bienvenue chez Renaître</h2>
        <p className="mt-3 text-[15px] leading-relaxed text-[#36302B]/75">
          Renaître est pensée comme un refuge. Vos données sensibles — humeurs, résultats du test
          d'Édimbourg, terme de naissance — sont stockées <strong>uniquement sur votre appareil</strong> et
          ne sont jamais transmises à un serveur.
        </p>
        <p className="mt-3 text-[14px] leading-relaxed text-[#36302B]/60">
          En continuant, vous acceptez ce fonctionnement. Vous pouvez tout effacer à tout moment depuis
          votre profil (RGPD Art. 17).
        </p>
        <button
          data-testid="consent-accept-btn"
          onClick={accept}
          className="mt-6 w-full rounded-full bg-[#C57B67] py-4 text-[15px] font-bold text-white transition-colors hover:bg-[#B56A63]"
        >
          J'ai compris, entrer dans Renaître
        </button>
        <Link
          to="/privacy-policy"
          data-testid="consent-privacy-link"
          className="mt-3 block text-center text-[13px] font-semibold text-[#C57B67]"
        >
          Lire la politique de confidentialité
        </Link>
      </div>
    </div>
  );
}
